import { rem } from "@certn/cascadia";
import { SectionMessage, useMediaQuery } from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

import { AuthHeader } from "./AuthHeading";
import { LanguageSelector } from "./LanguageSelector";
import { PassCodeForm } from "./PassCodeForm";

export function WelcomePage() {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const { mediaQuery } = useMediaQuery();
  const [error, setError] = useState<{ message: string; title: string }>();

  useEffect(() => {
    if (!location.state?.errorMessage) {
      return;
    }

    const errorType = location.state.errorType;

    setError({
      message: location.state.errorMessage,
      title:
        errorType === "info_blocked"
          ? t("Account temporarily locked")
          : t("Something went wrong"),
    });
    // remove location.state
    navigate(`/auth/welcome${location.search}`, { replace: true });
  }, [setError]);

  return (
    <>
      <LanguageSelector />
      <div
        className={css(
          mediaQuery({
            marginTop: [rem("space-10"), undefined],
          })
        )}
      >
        <AuthHeader
          title={t("Welcome to Certn")}
          subtitle={t(
            "Manage your personal identity & background checks in one place."
          )}
        />
        <div className={css({ margin: `${rem("space-6")} 0` })}>
          {error && (
            <SectionMessage
              icon="info"
              sectionTitle={error.title}
              type="danger"
            >
              {error.message}
            </SectionMessage>
          )}
        </div>
        <PassCodeForm />
      </div>
    </>
  );
}
